export const flowName = 'new-landing-page';
export enum StepName {
  // Step 1
  Intro = 'Intro',

  // Step 2
  PlanNewDesign = 'Plan new design',
  PlanWithSPR = 'Plan with SPR',

  // Step 3
  ContinuedPlanning = 'Continued planning',
  PlanFomVPC = 'Plan from VPC',
  PlanWithStorageBehind = 'Plan with StorageBehind',

  // Step 4
  Summary = 'Summary'
}

export const getStepLevel = (stepName: StepName) => {
  switch (stepName) {
    case StepName.Intro:
      return 1;
    case StepName.PlanNewDesign:
    case StepName.PlanWithSPR:
      return 2;
    case StepName.ContinuedPlanning:
    case StepName.PlanFomVPC:
    case StepName.PlanWithStorageBehind:
      return 3;
    case StepName.Summary:
      return 4;
    default:
      return 0;
  }
};
